import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { Box } from "@mui/material";
import { useTranslation } from "hhn-commons";
import Icon from "../../../common/Icon/Icon";
import { PatientDetailText } from "./PatientGroupChatListItem.style";

export const SocScheduleDate = ({ date }: { date: string }) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "patientGroup" });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        marginBottom: "5px"
      }}>
      <Icon
        icon={<CalendarTodayIcon />}
        sx={{
          fontSize: "16px",
        }}
      />
      <PatientDetailText data-testid="soc-date">
        <span>
          {" "}
          {tNs("soc")} {date}{" "}
        </span>
      </PatientDetailText>
    </Box>
  );
};
